import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BAR_CATEGORY_ID } from 'src/config-global';

import axios from '../../utils/axios';

export interface IMonthlySalesItem {
  _id: string;
  itemName: string;
  itemCode: string;
  totalQuantity: number;
  totalAmount: number;
}

interface IInitialState {
  summary: {
    status: 'idle' | 'loading' | 'success' | 'failure';
    error: string | undefined;
    data: IMonthlySalesItem[];
  };
}

const initialState: IInitialState = {
  summary: {
    status: 'idle',
    error: undefined,
    data: [],
  },
};

const monthlySales = createSlice({
  name: 'monthlySales',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMonthlySales.pending, (state) => {
        state.summary.status = 'loading';
      })
      .addCase(getMonthlySales.fulfilled, (state, action) => {
        state.summary.status = 'success';
        state.summary.data = action.payload;
      })
      .addCase(getMonthlySales.rejected, (state, action) => {
        state.summary.status = 'failure';
        state.summary.error = action.error.message;
      });
  },
});

export default monthlySales.reducer;

export const getMonthlySales = createAsyncThunk(
  'getMonthlySales',
  async (params: { startDate: string; endDate: string }) => {
    const { startDate, endDate } = params;
    try {
      const response = await axios.get(
        `inventory/analytics/transaction-item-amounts?startDate=${startDate}&endDate=${endDate}&transactionType=dispatch&categories=${BAR_CATEGORY_ID}&limit=5&sort=desc&sortBy=totalAmount`
      );

      return response.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);
